import React, { useMemo } from "react";

import { Agent } from "../../../../../../../../../../services";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";
import { DisabledCheckbox } from "../../../../../../../../../../components";

const MobileAppCellContent: React.FC<MobileAppCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(
		() => item.isAccessToApp ?? false,
		[item.isAccessToApp],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			<DisabledCheckbox value={content} />
		</CellContentRoot>
	);
};

declare namespace MobileAppCellContent {
	interface Props {
		item: Agent.Model;
	}
}

export default MobileAppCellContent;
